
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  resetPasswordButton: {
    id: "ResetPassword.button",
    defaultMessage: "Back to Login",
  },
});

export default MESSAGES;